export default __webpack_public_path__ + "static/media/38k.f2e79a55.md";